import React, { useState } from "react";
import "./Section1.css";
import "./Section2.css";
import "./Section3.css";
import "./Section4.css";
import "bootstrap/dist/css/bootstrap.min.css";
import illustration from "../Asset/desktop illustration 2.png";
import plusIconBlue from "../Asset/plus icon blue.png";
import tickIconOrange from "../Asset/tick icon orange.png";
import shieldIconBlue from "../Asset/shield icon blue.png";
import plusIconOrange from "../Asset/plus icon orange.png";
import tickIconBlue from "../Asset/tick icon blue.png";
import shieldIconOrange from "../Asset/shield icon orange.png";
import Question_img from "../Asset/Question.png";
import vector_icon from "../Asset/Vector 4 .png";
import Wave from "../Asset/svgviewer-png-output.png";
import Arrow from "../Assets/Arrow.svg";
import logo1 from "../Asset/injured man illustration.png";
import logo2 from "../Asset/locker illustration.png";
import { ReactComponent as ArrowIcon } from "../Asset/up-arrow-svgrepo-com.svg";
import { Link } from "react-router-dom";
import GroupHealth from "../Assets/group health icon.svg";
import GroupPersonalAccident from "../Assets/group accident icon.svg";
import GroupTermLife from "../Assets/group term icon.svg";
import FireBulglary from "../Assets/fire & burglary icon.svg";
import OfficePackage from "../Assets/Icon office package.svg";
import ShopOwner from "../Assets/shop owner icon.svg";
import ProfDoctor from "../Assets/prof indemnity for doctors icon.svg";
import ProfCompanies from "../Assets/prof indemnity for companies icon.svg";
import Workmen from "../Assets/workmen compensation icon.svg";
import SingleTransit from "../Assets/single transit policy icon.svg";
import MarineOpen from "../Assets/marine open policy icon.svg";
import SalesTurnOver from "../Assets/sales turnover policy icon.svg";
import DirectorsOfficers from "../Assets/Directors & Office  Insurance icon.svg";
import ErrorOmmision from "../Assets/errors & omission icon.svg";
import GeneralLiability from "../Assets/general liability icon.svg";
import ProductLiabilty from "../Assets/Product Liability icon.svg";
import CyberInsurance from "../Assets/cyber icon.svg";
import CrimeInsurance from "../Assets/crime icon.svg";
import GroupGratulty from "../Assets/Group (4).svg";
import GroupCreditLife from "../Assets/Group (5).svg";
import MotorFleetInsurance from "../Assets/Group 9130.svg";
import tree from "../Assets/Group 8986.svg";
import tree1 from "../Assets/23849466_6815593 1.svg";
import innerplus from "../Assets/innerplus.svg"; const Section4 = () => {
  const handleButtonClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="main-footer">
      <h3 className="main-heading">
        Ready to protect your business?{" "}
        <span className="heading">Scroll up and choose your coverage!</span>
      </h3>

      <div className="container-fluid">
        <div className="row bottom-row" >
          <div className="col-sm-4 col-md-3 d-md-block">
            <img src={logo2} alt="Logo 2" className="img-fluid1" />
          </div>

          <div className="col-sm-6 col-md-3 mt-2">
            <div
              className="btn text-white text-center"
              arrow
              onClick={handleButtonClick}
            >
              <p className="m-0">Take me to Top</p>
              <div className="icon-wrapper flex-column">
                <ArrowIcon className="arrow-icon" />
                <ArrowIcon className="arrow-icon" />
              </div>
            </div>
          </div>

          <div className="col-sm-4 col-md-3 d-none d-md-block">
            <img src={logo1} alt="Logo1" className="img-fluid2" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section4
